import $ from "jquery";
import Cookies from "js-cookie";

// If the values of those keys are changed the also have to be changed in the Goolge Tag Manager
const cookieConsentKey = "cookie_consent";
const acceptedKey = "accepted";
const declinedKey = "declined";

function removeGoogleCookies(): void {
  // Delete Google cookies when no consent is given
  Object.keys(Cookies.get())
    .filter((name) => name.match(/^(?:_ga|_gid|_gat_.*|_dc_gtm_.*|AMP_TOKEN|_gac_.*)$/))
    .forEach((googleCookieKey) => Cookies.remove(googleCookieKey));
}

function acceptGoogleAnalyticsCookies(): void {
  if (window.dataLayer == undefined) {
    window.dataLayer = [];
  }
  window.dataLayer.push({
    event: "cookiesAccepted",
  });
}

function acceptMatomoAnalyticsCookies(): void {
  if (window._paq == undefined) {
    window._paq = [];
  }
  window._paq.push(["setCookieConsentGiven"]);
}

$(() => {
  const consentModal = $("#cookieConsentModal");

  const cookieConsentValue = Cookies.get(cookieConsentKey);
  if (cookieConsentValue == undefined) {
    consentModal.on("shown.bs.modal", () => {
      consentModal.trigger("focus");
    });
    consentModal.modal({
      backdrop: "static",
      keyboard: false,
      show: true,
    });

    $("#acceptCookies").on("click", () => {
      Cookies.set(cookieConsentKey, acceptedKey, { sameSite: "none", expires: 90, secure: true });
      acceptGoogleAnalyticsCookies();
      acceptMatomoAnalyticsCookies();
    });

    $("#declineCookies").on("click", () => {
      Cookies.set(cookieConsentKey, declinedKey, { sameSite: "none", expires: 90, secure: true });
      removeGoogleCookies();
    });
  } else {
    consentModal.remove();
  }
  if (cookieConsentValue === acceptedKey) {
    acceptMatomoAnalyticsCookies();
  } else {
    removeGoogleCookies();
  }
});
